import Vue from '../main'

export default {
  name: 'nav',
  computed: {
    nav() {
      return [
        {
          _name: 'CSidebarNav',
          _children: [
            {
              _name: 'CSidebarNavTitle',
              _children: [Vue.$t('settings.menu.option.settings')],
              name: Vue.$t('settings.menu.option.settings'),
            },
            {
              _name: 'CSidebarNavDropdown',
              name: Vue.$t('settings.menu.option.profile'),
              id: 'Profile', // ? ID Usado para identificar o tipo de menu(menuType) definido na rota, pra poder deixar expandido o item quando selecionar um subitem
              items: [
                {
                  name: Vue.$t('settings.menu.option.basicInfo'),
                  class: 'CSidebarNavDropdownItem--disable',
                  to: { name: 'basic-info' },
                },
                {
                  name: Vue.$t('settings.menu.option.security'),
                  class: 'CSidebarNavDropdownItem--disable',
                  to: { name: 'user-security' },
                },
              ],
            },
            {
              _name: 'CSidebarNavDropdown',
              name: Vue.$t('settings.menu.option.organizationUser'),
              id: 'Organization & Users',
              items: [
                {
                  name: Vue.$t('settings.menu.option.organization'),
                  class: 'CSidebarNavDropdownItem--disable',
                  to: { name: 'mainOrganization' },
                },
                {
                  name: Vue.$t('settings.menu.option.subOrganization'),
                  class: 'CSidebarNavDropdownItem--disable',
                  to: { name: 'subOrganization' },
                },
                {
                  name: Vue.$t('settings.menu.option.user'),
                  class: 'CSidebarNavDropdownItem--disable',
                  to: { name: 'users-list' },
                },
              ],
            },
            {
              _name: 'CSidebarNavDropdown',
              name: Vue.$t('settings.menu.option.senders'),
              id: 'Senders',
              items: [
                {
                  name: Vue.$t('settings.menu.option.smsSenders'),
                  class: 'CSidebarNavDropdownItem--disable',
                  to: { name: 'senders-sms' },
                },
                {
                  name: Vue.$t('settings.menu.option.domainSenders'),
                  class: 'CSidebarNavDropdownItem--disable',
                  to: { name: 'senders-domain' },
                },
              ],
            },
            {
              _name: 'CSidebarNavDropdown',
              name: Vue.$t('settings.menu.option.transactions'),
              id: 'Transacations',
              items: [
                {
                  name: Vue.$t('settings.menu.option.history'),
                  class: 'CSidebarNavDropdownItem--disable',
                  to: { name: 'TransactionsHistory' },
                },
              ],
            },
            {
              _name: 'CSidebarNavDropdown',
              name: Vue.$t('settings.menu.option.whitelabel'),
              id: 'Whitelabel',
              items: [
                {
                  name: Vue.$t('settings.menu.option.whitelabel-config'),
                  class: 'CSidebarNavDropdownItem--disable',
                  to: { name: 'WhitelabelConfig' },
                },
              ],
            },
            {
              _name: 'CSidebarNavDropdown',
              name: Vue.$t('settings.menu.option.organization'),
              id: 'Organization Default',
              items: [
                {
                  name: Vue.$t('settings.menu.option.create-organization'),
                  class: 'CSidebarNavDropdownItem--disable',
                  to: { name: 'createOrganization-default' },
                },
              ],
            },
            // {
            //   _name: 'CSidebarNavItem',
            //   name: Vue.$t('settings.menu.option.integrations'),
            //   id: 'Integrations',
            //   class: 'CSidebarNavDropdownItem--disable',
            //   to: '/theme/typography',
            // },
            // {
            //   _name: 'CSidebarNavItem',
            //   name: Vue.$t('settings.menu.option.privacyCookies'),
            //   id: 'Privacy & Cookies',
            //   class: 'CSidebarNavDropdownItem--disable',
            //   to: '/theme/typography',
            // },
          ],
        },
      ]
    },
  },
}
